/* eslint-disable react/jsx-no-target-blank */
import { useNavigate } from 'react-router-dom'

function DivLeft({ fb, youTube, url, regione, apriBanner, geoloc, vaiAMaps }) {
    const navigate = useNavigate()
    return (<>
        <div className='divSinistraDesktop'>
            {fb && <a href={fb} style={{ textDecoration: 'none', color: 'navy', display: 'inline' }} target='_blank'>
                <img className='ms-1' src={require('../../image/icons8-fb-48.png')} alt='' width={30} />
            </a>}
            {youTube && <a href={youTube} style={{ textDecoration: 'none', color: 'navy', display: 'inline' }} target='_blank'>
                <img className='ms-1' src={require('../../image/icons8-instagram-48.png')} alt='' width={30} />
            </a>}
            {url !== '' && <a href={url} style={{ textDecoration: 'none', color: 'navy', display: 'inline' }} target='_blank'>
                <img className='ms-1' src={require('../../image/icons8-sito-web-30.png')} alt='' width={30} />
            </a>}
            <div style={{ borderRadius: '10px', backgroundColor: 'ghostwhite', marginTop: '1em', padding: '10px' }}>
                <p style={{ color: 'navy', cursor: 'pointer' }} onClick={() => { apriBanner('primoRegioni') }}>ALTRI EVENTI IN {regione}</p>
                <p style={{ color: 'navy', cursor: 'pointer' }} onClick={() => { apriBanner('primoAlberghi'); geoloc() }}>CERCA ALLOGGIO</p>
                <p style={{ color: 'navy', cursor: 'pointer' }} onClick={() => { apriBanner('primoRistoranti'); geoloc() }}>CERCA RISTORANTE</p>
                <p style={{ color: 'navy', cursor: 'pointer' }} onClick={() => { apriBanner('primoArtisti', 'artisti') }}>ARTISTI PER EVENTI</p>
                <p style={{ color: 'navy', cursor: 'pointer' }} onClick={() => { apriBanner('primoArtisti', 'foodTruck') }}>FOODTRUCK PER EVENTI</p>
                <p style={{ color: 'navy', cursor: 'pointer' }} onClick={() => { apriBanner('primoFornitori') }}>FORNITORI PER EVENTI</p>
                <p><a href='#borghi' style={{ color: 'navy', cursor: 'pointer', textDecoration: 'none' }}>BORGHI DA VISITARE</a></p>
                <p style={{ color: 'navy', cursor: 'pointer' }}>
                    <img src={require('../../image/icons8-visita-24.png')} alt='' /> <a href='#maps' onClick={vaiAMaps}>GOOGLE MAPS</a>
                </p>
            </div>
            <div style={{ borderRadius: '10px', backgroundColor: 'ghostwhite', marginTop: '1em', padding: '10px', color: 'blue' }}>
                <p style={{ cursor: 'pointer' }} onClick={() => { navigate('/addEvento') }}>CREA UN EVENTO</p>
                <p style={{ cursor: 'pointer' }} onClick={() => { navigate('/addArtista') }}>INSERISCI ARTISTA</p>
                <p style={{ cursor: 'pointer' }} onClick={() => { navigate('/addFoodTruck') }}>INSERISCI FOODTRUCK</p>
                <p style={{ cursor: 'pointer' }} onClick={() => { navigate('/addFornitore') }}>INSERISCI FORNITORE</p>
                <p style={{ cursor: 'pointer' }} onClick={() => { navigate('/addRisto') }}>INSERISCI RISTORANTE</p>
            </div>
        </div>
    </>)
}
export default DivLeft